import React from 'react'
import numeral from 'numeral'
import {
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from 'recharts'
import { useTranslation } from 'react-i18next'

import Progress from '../../Progress'

import styles from './styles.module.scss'
import { getCurrency } from '../../../../helpers/currencies'

const Placeholder = () => {
  const { t } = useTranslation()
  return (
    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontSize: 12, color: '#7b8794', padding: '24px 10px', fontWeight: 800, border: '1px solid #e1e8ef', borderRadius: 8, marginTop: 16}}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        aria-hidden="true"
        className="lucide lucide-receipt h-8 w-8"
      >
        <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z" />
        <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8M12 17.5v-11" />
      </svg>
      <div style={{color: '#333945', marginBottom : 4}}>{t('No expenses recorded')}</div>
      <div>{t('Pick a period to view')}</div>
    </div>
  )
}

const ProfitabilityExpenses = ({data}) => {
  if (!data.length) {
    return <Placeholder />
  }
  return (
    <div className={styles.container}>
      <div className={styles.chartContainer} style={{height: 256}}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={data} dataKey="amount" nameKey="expenses_type_name" cx="50%" cy="50%" outerRadius={90}>
              {data.map((item, i) => (
                <Cell key={i} fill={item.expenses_type_color} />
              ))}
            </Pie>
            <Tooltip
              contentStyle={{ background: '#fff', color: '#333945', border: '1px solid #CBD1D8', borderRadius: 8, fontSize: 12 }}
              formatter={(v) => numeral(v).format('0.00')}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className={styles.expensesContainer}>
        {
          data.map(((item, i) => {
            return (
              <div key={i} className={styles.expenseItem}>
                <div className={styles.expenseItemHeader}>
                  <div className={styles.dot} style={{backgroundColor: item.expenses_type_color}} />
                  <div className={styles.expenseName}>{item.expenses_type_name}</div>
                  <div className={styles.amount}>{item.amount}{getCurrency(item.currency_code).symbol}</div>
                </div>
                <div className={styles.expenseItemProgress}>
                  <Progress pct={item.percentage} />
                  <div>{item.percentage}%</div>
                </div>
              </div>
            )
          }))
        }
      </div>
    </div>
  )
}

export default ProfitabilityExpenses
